<template>
  <div class="wrapper kids-class-new">
    <div class="kids-class-new__shell">
      <section class="class-hero">
        <div class="class-hero__inner">
          <div class="class-hero__meta">
            <div style="width:100%;">
              <div style="display:flex;align-items:center;justify-content:space-between;gap:12px;width:100%;">
                <p class="class-hero__eyebrow" style="margin:0;">{{ currentDate() }}</p>
                <div style="display:flex;align-items:center;justify-content:flex-end;gap:10px;flex:0 0 auto;white-space:nowrap;">
                  <div style="font-size:14px;font-weight:700;color:#7c5a18;">Name: {{ operatorName || 'Not set' }}</div>
                  <button
                    type="button"
                    style="display:inline-flex;align-items:center;justify-content:center;border:1px solid #d7b46a;background:#fffaf0;color:#7c5a18;border-radius:999px;width:38px;height:38px;padding:0;cursor:pointer;flex:0 0 auto;"
                    aria-label="Update operator name"
                    title="Update name"
                    @click="openOperatorPrompt"
                  >
                    <CIcon name="cil-pencil" height="16" />
                  </button>
                </div>
              </div>
              <div style="display:flex;align-items:flex-end;justify-content:space-between;gap:16px;margin-top:4px;">
                <h2 class="class-hero__title">Class Dashboard New</h2>
                <div class="class-hero__total">Total: {{ meta.total }}</div>
              </div>
            </div>
          </div>

          <form class="class-search" @submit.prevent="submitSearch">
            <div class="class-search__field">
              <input
                v-model.trim="searchInput"
                type="text"
                class="class-search__input"
                placeholder="Search by child's name..."
                @keyup.enter.prevent="submitSearch"
              >
              <button
                v-if="searchInput"
                type="button"
                class="class-search__clear-mobile"
                aria-label="Clear"
                title="Clear"
                @click="clearSearch"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <label class="class-search__sort">
              <span class="class-search__sort-label">Filter by</span>
              <select v-model="sortMode" class="class-search__sort-select" @change="applyLocalFilters">
                <option value="alphabetical">Alphabetical</option>
                <option value="checkout_time">Check Out Time</option>
              </select>
            </label>
            <button
              type="button"
              class="class-search__button class-search__button--secondary"
              aria-label="Clear"
              title="Clear"
              @click="clearSearch"
            >
              <CIcon name="cil-x-circle" height="18" />
            </button>
          </form>

          <div class="class-filters">
            <label class="class-filter">
              <span class="class-filter__label">Class</span>
              <select v-model="ikid_class_name" class="class-filter__select" @change="handleClassFilter">
                <option value="0">Show All</option>
                <option v-for="item in listclass" :key="item.id" :value="item.name">{{ item.name }}</option>
              </select>
            </label>

            <label class="class-filter">
              <span class="class-filter__label">Status</span>
              <select v-model="checkin_status" class="class-filter__select" @change="handleStatusFilter">
                <option value="5">Show All</option>
                <option value="1">Check In</option>
                <option value="2">In Class</option>
                <option value="3">Queued</option>
                <option value="4">Check Out</option>
              </select>
            </label>
          </div>
        </div>
      </section>

      <section class="class-results">
        <div v-if="isLoadingInitial" class="class-results__state">
          <b-spinner variant="primary" label="Loading class dashboard" />
        </div>

        <div v-else-if="items.length === 0" class="class-results__state">
          No child found.
        </div>

        <div v-else class="class-grid">
          <article
            v-for="item in items"
            :key="item.id"
            class="class-card"
          >
            <div class="class-card__top">
              <img
                :src="getPhoto(item.get_photo)"
                :alt="item.name"
                class="class-card__avatar"
              >

              <div class="class-card__main">
                <div class="class-card__headline">
                  <h3 class="class-card__name">{{ item.name }}</h3>
                  <span
                    class="class-card__class"
                    :style="classBadgeStyle(item.class_name)"
                  >
                    {{ item.class_name || '-' }}
                  </span>
                </div>

                <div class="class-card__status-wrap">
                  <span :class="statusClass(item)" class="class-card__status">
                    {{ statusText(item) }}
                  </span>
                  <span v-if="item.checkin_status && item.checkin_status.log_time" class="class-card__time">
                    {{ formatTime(item.checkin_status.log_time) }}
                  </span>
                </div>
              </div>
            </div>

            <button
              v-if="canCheckOut(item)"
              type="button"
              class="class-card__action"
              :disabled="isActionDisabled(item.id)"
              @click="openCheckOut(item.id)"
            >
              {{ activeActionKidId === item.id ? 'Loading...' : 'Check Out' }}
            </button>
          </article>
        </div>
      </section>
    </div>

    <alertmodal />
    <div v-if="showOperatorPrompt" style="position:fixed;inset:0;background:rgba(19,24,32,.55);display:flex;align-items:center;justify-content:center;padding:20px;z-index:9999;">
      <div style="width:min(460px,100%);background:#fff;border-radius:20px;padding:24px;box-shadow:0 24px 80px rgba(17,24,39,.22);">
        <h3 style="margin:0 0 8px;font-size:24px;font-weight:800;color:#1f2937;">Enter Name</h3>
        <p style="margin:0 0 16px;color:#6b7280;">Name saved 1 day. Used for history log on this page.</p>
        <input
          v-model.trim="operatorDraft"
          type="text"
          class="class-search__input"
          :style="operatorError ? 'border-color:#dc2626;box-shadow:0 0 0 3px rgba(220,38,38,.12);' : ''"
          placeholder="name"
          @keyup.enter.prevent="saveOperatorName"
        >
        <p v-if="operatorError" style="margin:10px 0 0;color:#dc2626;font-size:13px;font-weight:700;">
          {{ operatorError }}
        </p>
        <div style="display:flex;justify-content:flex-end;gap:12px;margin-top:16px;">
          <button type="button" class="class-search__button" @click="saveOperatorName">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Pusher from 'pusher-js'
import EventBus from '@/eventBus'
import alertmodal from '@/views/alert/modal.vue'
import ikid from '@/services/ikid'

const CLASS_PALETTE = [
  { bg: '#fff1c7', text: '#8a6216' },
  { bg: '#dff4ff', text: '#0f5f9d' },
  { bg: '#ddf7e7', text: '#217247' },
  { bg: '#ffe3df', text: '#a44b3f' },
  { bg: '#efe6ff', text: '#6845a8' },
  { bg: '#e6f1ff', text: '#2b5f95' },
]

export default {
  name: 'KidsClassNew',
  components: {
    alertmodal,
  },
  data() {
    const url = window.location.href
    const index = url.indexOf('class=')
    let ikidClassName = url.slice(index).split('=')[1] || ''
    ikidClassName = ikidClassName ? ikidClassName.charAt(0).toUpperCase() + ikidClassName.slice(1) : 0

    return {
      form: {
        ikid_id: '',
        status: '',
        from: 'portal',
        source_channel: 'portal_kids_class',
        executed_by: '',
      },
      rawItems: [],
      items: [],
      listclass: [],
      meta: {
        total: 0,
        current_page: 1,
        per_page: 200,
        from: 0,
        to: 0,
      },
      current_page: 1,
      per_page: 200,
      searchInput: '',
      submittedKeyword: '',
      sortMode: 'alphabetical',
      is_active: 1,
      ikid_class_name: ikidClassName || 0,
      kid_class_id: '',
      checkin_status: 2,
      check_status: 2,
      searchDebounceTimer: null,
      refreshTimer: null,
      refreshQueued: false,
      refreshInFlight: false,
      refreshLastRunAt: 0,
      refreshIntervalMs: 2500,
      pusherClient: null,
      lastEventId: null,
      isLoadingInitial: true,
      activeActionKidId: null,
      operatorName: '',
      operatorDraft: '',
      showOperatorPrompt: false,
      operatorError: '',
    }
  },
  async mounted() {
    this.hydrateOperatorName()
    if (this.operatorName) {
      await this.loadClass()
      await this.loadData()
    } else {
      this.isLoadingInitial = false
      this.showOperatorPrompt = true
    }
    EventBus.$on('TABLE_UPDATE_KIDS_CLASS_TEACHER', this.handleTableUpdate)

    this.pusherClient = new Pusher('fbb60f501f4a91119030', {
      cluster: 'ap1',
      encrypted: true,
    })

    const channel = this.pusherClient.subscribe('kid-channel')
    channel.bind('status-change', this.handleStatusChange)
    channel.bind('status-cancel', this.handleStatusCancel)
  },
  beforeDestroy() {
    EventBus.$off('TABLE_UPDATE_KIDS_CLASS_TEACHER', this.handleTableUpdate)
    this.clearSearchDebounce()
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer)
      this.refreshTimer = null
    }
    if (this.pusherClient) {
      this.pusherClient.disconnect()
      this.pusherClient = null
    }
  },
  watch: {
    searchInput(value) {
      const keyword = (value || '').trim()
      this.clearSearchDebounce()

      if (keyword === '') {
        this.submittedKeyword = ''
        this.applyLocalFilters()
        return
      }

      this.searchDebounceTimer = window.setTimeout(() => {
        if (keyword === (this.submittedKeyword || '').trim()) return
        this.runSearch(keyword)
      }, 500)
    },
  },
  methods: {
    currentDate() {
      const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      const current = new Date()
      return current.getDate() + ' ' + months[current.getMonth()] + ' ' + current.getFullYear()
    },
    operatorStorageKey() {
      return 'ikid_operator_name_kids_class'
    },
    getOperatorCookie() {
      const prefix = this.operatorStorageKey() + '='
      const cookies = document.cookie ? document.cookie.split('; ') : []
      const match = cookies.find((cookie) => cookie.indexOf(prefix) === 0)
      return match ? decodeURIComponent(match.substring(prefix.length)) : ''
    },
    hydrateOperatorName() {
      const raw = this.getOperatorCookie()
      if (!raw) return

      this.operatorName = raw
      this.operatorDraft = raw
      this.form.executed_by = raw
    },
    openOperatorPrompt() {
      this.operatorDraft = this.operatorName
      this.operatorError = ''
      this.showOperatorPrompt = true
    },
    cancelOperatorPrompt() {
      this.operatorDraft = this.operatorName
      this.operatorError = ''
      this.showOperatorPrompt = false
    },
    async saveOperatorName() {
      const name = (this.operatorDraft || '').trim()
      if (!name) {
        this.operatorError = 'Name is required'
        return
      }
      this.operatorError = ''

      document.cookie = `${this.operatorStorageKey()}=${encodeURIComponent(name)}; max-age=86400; path=/`

      this.operatorName = name
      this.form.executed_by = name
      this.showOperatorPrompt = false

      if (!this.listclass.length && !this.rawItems.length) {
        this.isLoadingInitial = true
        await this.loadClass()
        await this.loadData()
      }
    },
    submitSearch() {
      const keyword = (this.searchInput || '').trim()
      this.clearSearchDebounce()
      this.runSearch(keyword)
    },
    clearSearch() {
      this.clearSearchDebounce()
      this.searchInput = ''
      this.submittedKeyword = ''
      this.applyLocalFilters()
    },
    clearSearchDebounce() {
      if (this.searchDebounceTimer) {
        window.clearTimeout(this.searchDebounceTimer)
        this.searchDebounceTimer = null
      }
    },
    runSearch(keyword) {
      this.submittedKeyword = keyword
      this.applyLocalFilters()
    },
    async loadClass() {
      const res = await ikid.getIkidClassDashboard(this.$route.query.Pud)
      this.listclass = res.data || []
    },
    loadData(options = {}) {
      const useEventGuard = options.useEventGuard !== false
      this.kid_class_id = this.listclass.find((item) => item.name === this.ikid_class_name)?.id || 0

      const params = {
        page: this.current_page,
        per_page: this.per_page,
        sortby: 'checkin_status',
        sortbydesc: 'DESC',
        is_active: this.is_active,
        ikid_class_name: this.ikid_class_name,
        checkin_status: this.checkin_status,
        check_status: this.check_status,
        kid_class_id: this.kid_class_id,
      }
      if (useEventGuard) {
        params.if_modified_since_event_id = this.lastEventId
      }

      return Promise.all([
        ikid.getIkidClassDashboard(params),
        ikid.getIkidClassDataSource(params),
      ]).then(([classRes, listRes]) => {
        this.listclass = classRes.data || this.listclass

        if (listRes.not_changed) {
          this.lastEventId = listRes.event_id || this.lastEventId
          if (useEventGuard && (!this.rawItems || this.rawItems.length === 0)) {
            return this.loadData({ useEventGuard: false })
          }
          this.applyLocalFilters()
          return
        }

        this.lastEventId = listRes.event_id || this.lastEventId
        const getData = listRes.data || {}
        this.rawItems = Array.isArray(getData.data) ? getData.data : []
        this.applyLocalFilters()
      }).catch((err) => {
        this.showError(err, 'Failed to load class dashboard')
      }).finally(() => {
        this.isLoadingInitial = false
      })
    },
    loadDataKid() {
      this.kid_class_id = this.listclass.find((item) => item.name === this.ikid_class_name)?.id || 0
      const params = {
        page: this.current_page,
        per_page: this.per_page,
        sortby: 'checkin_status',
        sortbydesc: 'DESC',
        is_active: this.is_active,
        ikid_class_name: this.ikid_class_name,
        checkin_status: this.checkin_status,
        check_status: this.check_status,
        kid_class_id: this.kid_class_id,
        if_modified_since_event_id: this.lastEventId,
      }

      return ikid.getIkidClassDataSource(params).then((res) => {
        if (res.not_changed) {
          this.lastEventId = res.event_id || this.lastEventId
          this.applyLocalFilters()
          return
        }

        this.lastEventId = res.event_id || this.lastEventId
        const getData = res.data || {}
        this.rawItems = Array.isArray(getData.data) ? getData.data : []
        this.applyLocalFilters()
      }).catch((err) => {
        this.showError(err, 'Failed to refresh class dashboard')
      })
    },
    handleTableUpdate(data) {
      if (data) {
        this.loadData()
      }
    },
    handleStatusChange(data) {
      if (this.kid_class_id === data.kid_class_id || this.kid_class_id === 0) {
        this.queueRealtimeRefresh(true)
      }
    },
    handleStatusCancel() {
      this.queueRealtimeRefresh(false)
    },
    resolveStatusCode(item) {
      const numericStatus = Number(item && item.check_status)
      if (!Number.isNaN(numericStatus) && numericStatus > 0) return numericStatus
      const action = item && item.checkin_status && item.checkin_status.action
      if (action === 'check in') return 1
      if (action === 'in class') return 2
      if (action === 'queued') return 3
      if (action === 'check out') return 4
      return 0
    },
    applyLocalFilters() {
      let filtered = Array.isArray(this.rawItems) ? [...this.rawItems] : []
      const query = (this.submittedKeyword || '').toLowerCase()

      if (query !== '') {
        filtered = filtered.filter((item) => (item.name || '').toLowerCase().includes(query))
      }

      if (this.ikid_class_name && this.ikid_class_name !== 0 && this.ikid_class_name !== '0') {
        const classFilter = String(this.ikid_class_name).toLowerCase()
        filtered = filtered.filter((item) => String(item.class_name || '').toLowerCase() === classFilter)
      }

      const statusFilter = Number(this.checkin_status)
      if (!Number.isNaN(statusFilter) && statusFilter !== 0 && statusFilter !== 5) {
        filtered = filtered.filter((item) => this.resolveStatusCode(item) === statusFilter)
      }

      if (this.sortMode === 'alphabetical') {
        filtered.sort((a, b) => (a.name || '').localeCompare(b.name || ''))
      } else if (this.sortMode === 'checkout_time') {
        const toTime = (value) => {
          const time = value ? new Date(String(value).replace(' ', 'T')).getTime() : NaN
          return Number.isNaN(time) ? Infinity : time
        }
        filtered.sort((a, b) => {
          const timeA = toTime(a && a.checkin_status && a.checkin_status.log_time)
          const timeB = toTime(b && b.checkin_status && b.checkin_status.log_time)
          if (timeA === timeB) return 0
          return timeA < timeB ? -1 : 1
        })
      }

      this.items = filtered
      this.meta = {
        total: filtered.length,
        current_page: 1,
        per_page: this.per_page,
        from: filtered.length > 0 ? 1 : 0,
        to: filtered.length,
        is_active: this.is_active,
        ikid_class_name: this.ikid_class_name,
        checkin_status: this.checkin_status,
        check_status: this.check_status,
        kid_class_id: this.kid_class_id,
      }
    },
    queueRealtimeRefresh(kidOnly = false) {
      this.refreshQueued = kidOnly ? 'kid' : 'full'
      this.flushRealtimeRefresh()
    },
    flushRealtimeRefresh() {
      if (!this.refreshQueued || this.refreshInFlight || this.refreshTimer) return
      const elapsed = Date.now() - this.refreshLastRunAt
      const waitMs = Math.max(0, this.refreshIntervalMs - elapsed)

      this.refreshTimer = setTimeout(async () => {
        this.refreshTimer = null
        if (!this.refreshQueued || this.refreshInFlight) return
        const mode = this.refreshQueued
        this.refreshQueued = false
        this.refreshInFlight = true
        this.refreshLastRunAt = Date.now()
        try {
          if (mode === 'kid') {
            await this.loadDataKid()
          } else {
            await this.loadData()
          }
        } finally {
          this.refreshInFlight = false
          if (this.refreshQueued) this.flushRealtimeRefresh()
        }
      }, waitMs)
    },
    handleClassFilter() {
      const path = window.location.href.split('?')[0]
      let url = path
      if (this.ikid_class_name !== '0' && this.ikid_class_name !== 0) {
        url = path + '?class=' + this.ikid_class_name
      }
      history.replaceState({}, null, url.toLowerCase())
      this.loadData({ useEventGuard: false })
    },
    handleStatusFilter() {
      this.loadData({ useEventGuard: false })
    },
    openCheckOut(uuid) {
      if (this.activeActionKidId) return
      if (!this.operatorName) {
        this.openOperatorPrompt()
        return
      }
      this.activeActionKidId = uuid
      this.form.ikid_id = uuid
      this.form.status = 4
      this.form.executed_by = this.operatorName

      ikid.changeStatusKidQueue(this.form).then(() => {
        EventBus.$emit('TABLE_UPDATE_KIDS_CLASS_TEACHER', true)
      }).catch((err) => {
        this.showError(err, 'Failed to check out kid')
      }).finally(() => {
        this.activeActionKidId = null
      })
    },
    getPhoto(data) {
      if (data && data.filename) {
        return axios.defaults.baseURL + '/getfile/memberphoto/' + data.filename
      }
      return axios.defaults.baseURL + '/getfile/memberphoto/no_photo.jpg'
    },
    formatTime(logTime) {
      const date = new Date(logTime)
      return date.toLocaleTimeString('en-US', {
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      })
    },
    classBadgeStyle(className) {
      const label = className || ''
      let sum = 0
      for (let i = 0; i < label.length; i++) sum += label.charCodeAt(i)
      const tone = CLASS_PALETTE[sum % CLASS_PALETTE.length]
      return {
        backgroundColor: tone.bg,
        color: tone.text,
      }
    },
    statusText(item) {
      const action = item && item.checkin_status ? item.checkin_status.action : null
      if (!action) return 'Unconfirmed'
      if (action === 'queued') return 'In Queued'
      if (action === 'in class') return 'In Class'
      if (action === 'check out') return 'Check Out'
      if (action === 'check in') return 'Check In'
      return action
    },
    statusClass(item) {
      const action = item && item.checkin_status ? item.checkin_status.action : null
      if (!action) return 'class-card__status--default'
      if (action === 'queued') return 'class-card__status--warning'
      if (action === 'in class') return 'class-card__status--success'
      if (action === 'check out') return 'class-card__status--danger'
      if (action === 'check in') return 'class-card__status--info'
      return 'class-card__status--default'
    },
    canCheckOut(item) {
      return item &&
        item.checkin_status &&
        item.checkin_status.action === 'queued' &&
        ['Incredible', 'Super', 'Wonder'].includes(item.class_name)
    },
    isActionDisabled(kidId) {
      return !!this.activeActionKidId && this.activeActionKidId !== kidId
    },
    showError(err, fallbackMessage) {
      const message = err && err.response && err.response.data && err.response.data.message
        ? err.response.data.message
        : fallbackMessage
      EventBus.$emit('OPEN_MODAL_ALERT', {
        title: 'Error',
        mode: 'danger',
        data: message,
      })
    },
  },
}
</script>

<style scoped>
.kids-class-new {
  height: 100%;
  padding: 0 !important;
  background:
    radial-gradient(circle at top, rgba(47, 109, 201, 0.12), transparent 35%),
    linear-gradient(180deg, #f7fbff 0%, #eef4fb 100%);
}

.kids-class-new__shell {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.class-hero {
  position: sticky;
  top: 0;
  z-index: 5;
  flex: 0 0 auto;
  padding: 14px 14px 16px;
  background:
    linear-gradient(180deg, rgba(247, 251, 255, 0.98) 0%, rgba(238, 244, 251, 0.94) 100%);
  border-bottom: 1px solid rgba(199, 215, 236, 0.8);
}

.class-hero__inner {
  max-width: 1180px;
  margin: 0 auto;
}

.class-hero__meta {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;
  margin-bottom: 12px;
}

.class-hero__eyebrow {
  margin: 0 0 4px;
  color: #68819d;
  font-size: 12px;
  font-weight: 600;
}

.class-hero__title {
  margin: 0;
  color: #16375d;
  font-size: 24px;
  font-weight: 700;
}

.class-hero__total {
  color: #16375d;
  font-size: 22px;
  font-weight: 700;
  white-space: nowrap;
}

.class-search {
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 760px;
}

.class-search__field {
  position: relative;
  flex: 1;
  min-width: 0;
}

.class-search__input {
  width: 100%;
  min-height: 42px;
  padding: 0 16px;
  border: 1px solid #c7d7ec;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 18px 40px rgba(20, 63, 108, 0.08);
  color: #17324d;
  font-size: 14px;
  outline: none;
}

.class-search__clear-mobile {
  display: none;
}

.class-search__button {
  min-width: 56px;
  min-height: 50px;
  border: none;
  border-radius: 999px;
  background: #1367b4;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.class-search__button:hover {
  opacity: 0.92;
  transform: translateY(-1px);
}

.class-search__button--secondary {
  background: #fff;
  border: 1px solid #c7d7ec;
  color: #315777;
}

.class-search__sort {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
}

.class-search__sort-label {
  color: #6c8198;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  white-space: nowrap;
}

.class-search__sort-select {
  min-height: 42px;
  padding: 0 12px;
  border: 1px solid #c7d7ec;
  border-radius: 999px;
  background: #fff;
  color: #17324d;
  font-size: 14px;
  outline: none;
}

.class-filters {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 220px));
  gap: 12px;
  margin-top: 14px;
}

.class-filter {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.class-filter__label {
  color: #6c8198;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}

.class-filter__select {
  min-height: 44px;
  padding: 0 14px;
  border: 1px solid #c7d7ec;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.92);
  color: #17324d;
  font-size: 14px;
  outline: none;
}

.class-results {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  max-width: 1180px;
  width: 100%;
  margin: 0 auto;
  padding: 18px 14px 24px;
}

.class-results__state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 220px;
  border: 1px dashed #c9d6e6;
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.72);
  color: #5f7691;
  font-size: 18px;
}

.class-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

.class-card {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 22px 22px 20px;
  border: 1px solid #cfdae8;
  border-radius: 24px;
  background: #fff;
  box-shadow: 0 18px 36px rgba(18, 57, 99, 0.08);
}

.class-card__top {
  display: flex;
  align-items: center;
  gap: 16px;
}

.class-card__avatar {
  width: 76px;
  height: 76px;
  border: 4px solid #eef3f8;
  border-radius: 50%;
  object-fit: cover;
  background: #f5f8fc;
  flex: 0 0 auto;
}

.class-card__main {
  flex: 1;
  min-width: 0;
}

.class-card__headline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.class-card__name {
  margin: 0;
  color: #182433;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
}

.class-card__class {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.class-card__status-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  flex-wrap: wrap;
}

.class-card__status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 110px;
  padding: 7px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}

.class-card__status--default {
  background: #eef4fb;
  color: #507194;
}

.class-card__status--info {
  background: #dff0ff;
  color: #1663a7;
}

.class-card__status--warning {
  background: #fff0c9;
  color: #946809;
}

.class-card__status--success {
  background: #d9f8dd;
  color: #21693a;
}

.class-card__status--danger {
  background: #ffe1e1;
  color: #b33f3f;
}

.class-card__time {
  color: #63778d;
  font-size: 13px;
  font-weight: 700;
}

.class-card__action {
  width: 100%;
  min-height: 48px;
  border: none;
  border-radius: 999px;
  background: #d34545;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.class-card__action:hover:not(:disabled) {
  opacity: 0.93;
  transform: translateY(-1px);
}

.class-card__action:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

@media (max-width: 768px) {
  .class-hero {
    padding: 12px 12px 14px;
  }

  .class-hero__meta {
    flex-direction: column;
    align-items: flex-start;
  }

  .class-hero__total {
    font-size: 20px;
  }

  .class-search {
    flex-direction: row;
    align-items: stretch;
  }

  .class-search__input {
    min-width: 0;
    min-height: 42px;
    font-size: 16px;
    padding: 0 46px 0 18px;
  }

  .class-search__sort-label {
    display: none;
  }

  .class-search__clear-mobile {
    position: absolute;
    top: 50%;
    right: 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    padding: 0;
    border: 1px solid #d4dfec;
    border-radius: 50%;
    background: #f3f7fb;
    color: #41627f;
    font-size: 20px;
    font-weight: 700;
    transform: translateY(-50%);
    cursor: pointer;
  }

  .class-search__button {
    min-width: 54px;
    min-height: 54px;
    flex: 0 0 auto;
  }

  .class-search__button--secondary {
    display: none;
  }

  .class-filters {
    grid-template-columns: 1fr;
  }

  .class-results {
    padding: 16px 12px 20px;
  }

  .class-grid {
    grid-template-columns: 1fr;
  }

  .class-card {
    width: 100%;
  }

  .class-card__headline {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
